import { useRef, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, fileUrl, formatApiError } from "@/lib/api";

export const ImageUpload = ({ value, onChange, worldId, label = "Upload image", testId = "image-upload", tall = false }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    if (worldId) fd.append("world_id", worldId);
    setBusy(true);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div className={`relative rounded-xl border border-dashed border-line bg-canvas overflow-hidden ${tall ? "h-56" : "h-36"}`}>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
      {value ? (
        <>
          <img src={fileUrl(value)} alt="" className="w-full h-full object-cover" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange(null)} data-testid={`${testId}-remove`}
            className="absolute top-2 right-2 p-1.5 rounded-full bg-black/70 text-white hover:bg-rose-600 transition-colors">
            <X className="w-3.5 h-3.5" />
          </button>
        </>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`${testId}-button`}
          className="w-full h-full flex flex-col items-center justify-center gap-2 text-slate-500 hover:text-amber-400 transition-colors">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <ImagePlus className="w-5 h-5" />}
          <span className="text-xs">{busy ? "Uploading..." : label}</span>
        </button>
      )}
    </div>
  );
};
